/* eslint-disable react/prop-types */
import React from 'react';

const PortionLine = (props) => {
    const {
        portions, text, weightValue, weightText,
    } = props;

    return (
        <span className="blackhead-dish-description-about__portion LP_c5-1 LPd_c5-1">
            <span className="num">{weightValue}</span>
            <span className="text weight-text">
                {weightText}
            </span>
            <span className="weight-portions-divider">/</span>
            <span className="num">{portions}</span>
            <span className="text portions-text">
                {text}
            </span>
        </span>
    );
};

export default PortionLine;
